/**
 * @fileoverview gRPC-Web generated client stub for billing.private.refundpolicy
 * @enhanceable
 * @public
 */

// GENERATED CODE -- DO NOT EDIT!


import * as grpcWeb from "grpc-web";

import {
  GetRefundPolicyRequest,
  GetRefundPolicyResponse,
  UpdateRefundPolicyRequest,
  UpdateRefundPolicyResponse} from "./refundpolicy_pb";

export class RefundPolicyServiceClient {
  client_: grpcWeb.AbstractClientBase;
  hostname_: string;
  credentials_: null | { [index: string]: string; };
  options_: null | { [index: string]: string; };

  constructor (hostname: string,
               credentials?: null | { [index: string]: string; },
               options?: null | { [index: string]: string; }) {
    if (!options) options = {};
    if (!credentials) credentials = {};
    options["format"] = "text";

    this.client_ = new grpcWeb.GrpcWebClientBase(options);
    this.hostname_ = hostname;
    this.credentials_ = credentials;
    this.options_ = options;
  }

  methodInfoUpdateRefundPolicy = new grpcWeb.AbstractClientBase.MethodInfo(
    UpdateRefundPolicyResponse,
    (request: UpdateRefundPolicyRequest) => {
      return request.serializeBinary();
    },
    UpdateRefundPolicyResponse.deserializeBinary
  );

  updateRefundPolicy(
    request: UpdateRefundPolicyRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.Error,
               response: UpdateRefundPolicyResponse) => void) {
    return this.client_.rpcCall(
      this.hostname_ +
        "/billing.private.refundpolicy.RefundPolicyService/UpdateRefundPolicy",
      request,
      metadata || {},
      this.methodInfoUpdateRefundPolicy,
      callback);
  }

  methodInfoGetRefundPolicy = new grpcWeb.AbstractClientBase.MethodInfo(
    GetRefundPolicyResponse,
    (request: GetRefundPolicyRequest) => {
      return request.serializeBinary();
    },
    GetRefundPolicyResponse.deserializeBinary
  );

  getRefundPolicy(
    request: GetRefundPolicyRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.Error,
               response: GetRefundPolicyResponse) => void) {
    return this.client_.rpcCall(
      this.hostname_ +
        "/billing.private.refundpolicy.RefundPolicyService/GetRefundPolicy",
      request,
      metadata || {},
      this.methodInfoGetRefundPolicy,
      callback);
  }

}

